import Heading from '@tiptap/extension-heading';
import { ReactNodeViewRenderer } from '@tiptap/react';
import { HeadingWithSectionMenuView } from '../components/HeadingWithSectionMenuView';

export const HeadingWithSectionMenu = Heading.extend({
  addNodeView() {
    return ReactNodeViewRenderer(HeadingWithSectionMenuView);
  },
});
